import { IFindCouponsQuary, IPopupActivity } from '@/schemas/activities';
import { ApiConfigs, Response } from '@/schemas/service';
import { ICouponPopUpDataItem } from '@/schemas/coupon';
import { request } from './request';

const api: ApiConfigs = {
  getPopupActivities: {
    url: '/health/api/v1/activity/queryPopupActivities',
    method: 'GET'
  },
  findCoupons: {
    url: '/health/api/v1/coupon/queryCouponsByActivityCode',
    method: 'POST'
  }
};

const activities = {
  async getPopupActivities() {
    try {
      const response: Response<IPopupActivity[]> = await request(
        api.getPopupActivities,
        {},
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { result } = response;

      return result || Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async findCouponPopupInfo(query: IFindCouponsQuary) {
    try {
      const response: Response<ICouponPopUpDataItem[]> = await request(
        api.findCoupons,
        {
          ...query
        }
      );

      const { result } = response;
      return result || Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default activities;
